import React from 'react';

import SnippetEditor from './SnippetEditor';
import {tagEditorField} from "./snippetUtils";
import FroalaEditor from 'froala-editor';

const MailingLabelSnippetEditor = (props) => (
  <SnippetEditor
    {...props}
    initialFormState={{
      snippet: {
        name: '',
        subject: 'Avery_5160',
        font_size: '9'
      }
    }}
    fields={[
      {displayName: 'Name', canonicalName: 'name'},
      tagEditorField,
      {displayName: 'Type', canonicalName: 'subject', type: 'select', options: [
        {displayName: 'Avery 5160', canonicalName: 'Avery_5160'},
        {displayName: 'Avery 5162', canonicalName: 'Avery_5162'},
        {displayName: 'Avery 5163', canonicalName: 'Avery_5163'},
        {displayName: 'Avery 5366', canonicalName: 'Avery_5366'},
        {displayName: 'Avery 5384', canonicalName: 'Avery_5384'},
        {displayName: 'Avery 5395', canonicalName: 'Avery_5395'},
        {displayName: 'Avery 5961', canonicalName: 'Avery_5961'},
        {displayName: 'Envelope 10', canonicalName: 'Envelope_10'}
      ]},
      {displayName: 'Font size', canonicalName: 'font_size', options: [
        {displayName: '9', canonicalName: '9'},
        {displayName: '10', canonicalName: '10'},
        {displayName: '11', canonicalName: '11'},
        {displayName: '12', canonicalName: '12'},
        {displayName: '13', canonicalName: '13'},
        {displayName: '14', canonicalName: '14'},
        {displayName: '16', canonicalName: '16'},
        {displayName: '18', canonicalName: '18'},
        {displayName: '20', canonicalName: '20'},
        {displayName: '22', canonicalName: '22'},
        {displayName: '24', canonicalName: '24'}
      ]}
    ]}
    showFormatting={false}
    froalaOptions={{
      enter: FroalaEditor.ENTER_BR
    }}
  />
);

export default MailingLabelSnippetEditor;
